export enum PaymentMethodEnum {
    WEB3_WALLET = 'WEB3_WALLET',
    EXTERNAL = 'EXTERNAL',
    INTERNAL = 'INTERNAL',
    PAP_BALANCE = 'PAP_BALANCE',
};
